import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { capitalize } from 'lodash'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import ReviewFilesList from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/ReviewStep/ReviewData/ReviewFilesList'
import Button from '@Components/Buttons/Button'

interface ReviewDataProps {
    onDownloadWorkReport?: () => void
}

const ReviewData = ({ onDownloadWorkReport }: ReviewDataProps) => {
    const { catalogTransferWizardStore, rightsholderStore } = useContext(StoresContext)
    const sourcePublishers = catalogTransferWizardStore.currentCatalogTransfer?.sourcePublishers ?? []
    const sourcePublisherNames = sourcePublishers.map((publisher) => publisher.publisherName).join(', ')
    const sourcePublisherNumbers = sourcePublishers
        .map((publisher) => publisher.hfaPublisherNumber)
        .filter((number) => number)
        .join(', ')

    return (
        <>
            <section className="review-content">
                <section className="review-content">
                    <div className="review-content-area">
                        <p>
                            <strong>Catalog Information</strong>
                        </p>
                        <p>
                            <strong>Writer(s)</strong>
                            <div>{catalogTransferWizardStore.currentCatalogTransfer?.writerNames}</div>
                        </p>
                        <div className="review-content-item">
                            <p>
                                <strong>Details of Submitting Member</strong>
                            </p>
                            <div>
                                Email:{' '}
                                {tableCellSanitizer(
                                    catalogTransferWizardStore.currentCatalogTransfer?.submittingMember.email
                                )}
                            </div>
                            <div>Member Name: {rightsholderStore.currentRightsholder?.name}</div>
                            <div>
                                Member's Publisher Account Number (P#):{' '}
                                {rightsholderStore.currentRightsholder?.hfaPublisherNumber}
                            </div>
                        </div>
                        <div className="review-content-item">
                            <p>
                                <strong>Relinquishing Publisher</strong>
                            </p>

                            <div>Publisher Name: {sourcePublisherNames}</div>
                            <div>P Number: {sourcePublisherNumbers}</div>
                        </div>
                        <div className="review-content-item">
                            <p>
                                <strong>Transfer Details</strong>
                            </p>
                            <div>
                                Catalog Type: {capitalize(catalogTransferWizardStore.catalogTransferDTO.transferType)}
                            </div>
                        </div>
                        <div className="review-content-item">
                            <p>
                                <strong>Effective Date</strong>
                            </p>
                            <div>
                                {catalogTransferWizardStore.catalogTransferDTO.effectiveDate?.toLocaleDateString()}
                            </div>
                        </div>
                    </div>
                    <div className="review-content-area">
                        <div className="ct-works-summary-header">
                            <p>
                                <strong>Works Summary</strong>
                            </p>
                            {onDownloadWorkReport && (
                                <Button mainColor type="secondary" onClick={onDownloadWorkReport}>
                                    Download Work Report
                                </Button>
                            )}
                        </div>
                        <div className="review-content-item">
                            <p>
                                <strong>Works being transferred</strong>
                            </p>
                            <div>{catalogTransferWizardStore.currentCatalogTransfer?.workCount}</div>
                        </div>
                    </div>
                    <div className="review-content-area">
                        <div className="review-content-item">
                            <p>
                                <strong>Document(s) Attached</strong>
                            </p>
                            <div>
                                <ReviewFilesList
                                    uploadedDocs={catalogTransferWizardStore.currentCatalogTransfer?.uploadedDocs}
                                />
                            </div>
                        </div>
                        <div className="review-content-item">
                            <p>
                                <strong>Acquiring Publisher</strong>
                            </p>
                            <div>
                                Administrator Name:{' '}
                                {catalogTransferWizardStore.currentCatalogTransfer?.targetPublisher?.publisherName}
                            </div>
                            <div>
                                Administrator Publisher Number (P#):{' '}
                                {catalogTransferWizardStore.currentCatalogTransfer?.targetPublisher?.hfaPublisherNumber}
                            </div>
                            <div>
                                Administrator IPI Number:{' '}
                                {catalogTransferWizardStore.currentCatalogTransfer?.targetPublisher?.ipiNumber}
                            </div>
                        </div>
                        <div className="review-content-item">
                            <p>
                                <strong>Writers</strong>
                            </p>
                            <div>{catalogTransferWizardStore.catalogTransferDTO.writerNames}</div>
                        </div>
                        <div className="review-content-item">
                            <p>
                                <strong>Additional details</strong>
                            </p>
                            <div>{catalogTransferWizardStore.catalogTransferDTO.supplementalInfo}</div>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}
export default ReviewData
